import { HttpClient } from '@angular/common/http';
import { Component, ElementRef, Input, TemplateRef, ViewChild } from '@angular/core';
import DashboardSearchCriteria from 'src/app/interfaces/dashboardSearchCriteria';
import { UserProfile } from 'src/app/interfaces/UserProfile';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { DateTime } from 'luxon';
import { environment } from 'src/environments/environment';
import { Router } from '@angular/router';
import RenderDriverReportRequest from 'src/app/interfaces/renderReportRequest';
import { DriverReportView } from 'src/app/interfaces/driverReportView';
import { RecordsService } from 'src/app/services/records.service';
import { DriverDashboardRecord } from 'src/app/interfaces/driverDashboardRecord';
import { CelllinkrendererComponent } from '../cellrenderers/celllinkrenderer/celllinkrenderer/celllinkrenderer.component';
import { CustomercellbuttonrendererComponent } from '../cellrenderers/customercellbuttonrenderer/customercellbuttonrenderer/customercellbuttonrenderer.component';
import { CheckboxcellrendererComponent } from '../cellrenderers/checkboxcellrenderer/checkboxcellrenderer.component';
import { DriverRecordRequestService } from 'src/app/services/driverrecordrequest.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AuditService } from 'src/app/services/audit.service';
import { TranslatorService } from 'src/app/services/translator.service';
import { GeneralService } from 'src/app/services/general.service';
import { GridApi } from '@ag-grid-community/core';

@Component({
    selector: 'app-dashboardgrid',
    templateUrl: './dashboardgrid.component.html',
    styleUrls: ['./dashboardgrid.component.scss'],
    standalone: false
})
export class DashboardgridComponent {
    @Input() searchCriteria: DashboardSearchCriteria = { searchString: '' };
    oldSearchCriteria: DashboardSearchCriteria = { searchString: '' };

    lang: string = '';
    loadingText: string = 'Loading...';

    gridOptions: any = {
        suppressHorizontalScroll: true,
        rowClassRules: {
            'row-expired': (params: any) => {
                const expired = DateTime.now()
                    .minus({ hours: Number(environment.APP_DRIVER_RECORD_EXPIRATION_HOURS) })
                    .endOf('hour');
                return params.data?.requestDate && DateTime.fromISO(params.data.requestDate) < expired;
            }
        }
    };
    domLayout: any = 'autoHeight';
    defaultColDef: any = {
        resizable: true,
        wrapText: true
    };
    overlayLoadingTemplate: any = `<span class="ag-overlay-loading-center">${this.loadingText}</span>`;
    overlayNoRowsTemplate: any = '<span class="italic" id="noResultsFound">No results found</span>';
    columnDefs: [] | any = [];
    rowData$: DriverDashboardRecord[] = [];
    paginationPageSize = 10;
    paginationPageSizeSelector = [10, 20, 50, 100, 250];

    frameworkComponents: any;
    loadingCellRenderer: any;
    loadingCellRendererParams: any;

    voodooComplete: boolean = false;
    gridLanguage: string = '';

    showProbationModal: boolean = false;
    showPendingUnderReviewModal: boolean = false;
    isSubmitStatus: boolean = false;
    isResubmitStatus: boolean = false;
    probationButtonText: string = '';
    coversheetType: string = '';
    isLoading: boolean = true;
    currentAuthCode: string = '';
    isIahCustomer: boolean = false;
    showUploadModal: boolean = false;
    currentTrans: any = {
        authCode: '',
        probationStatusId: '',
        documentId: '',
        firstName: '',
        lastName: '',
        requestDate: ''
    };
    isUploading: boolean = false;
    username: string = '';
    userProfile: UserProfile | undefined;
    pdfUrl: string = '';
    probationDocuments: any = [];
    isResubmit: boolean = false;
    isValidFileType: boolean = true;
    showMonitorToast: boolean = false;
    monitorToastLastName: string = '';
    monitorToastOptIn: boolean = false;
    showMonitorErrorToast: boolean = false;
    monitorErrorToastIs401: boolean = false;
    monitorErrorToastIs403: boolean = false;
    monitorErrorToast403AuthCode: string = '';
    authMethod: string = 'Login.gov';
    accessedVia: string = 'CustomerDashboard';
    customerId: string = '';
    gridData: any = {};
    doCheckCount: number = 0;
    invFileTypeModal: any;
    private gridApi!: GridApi;

    // private widthChangeListenerFunction: (event: Event) => void;

    @ViewChild('SubmitOrResubmitModal')
    submitOrResubmitModal!: TemplateRef<any>;

    @ViewChild('UploadModal')
    uploadModal!: TemplateRef<any>;

    @ViewChild('InvalidFileTypeModal')
    invalidFileTypeModal!: TemplateRef<any>;

    @ViewChild('PendingUnderReviewModal')
    pendingUnderReviewModal!: TemplateRef<any>;

    @ViewChild('StopMonitorConfirmModal')
    stopMonitorConfirmModal!: TemplateRef<any>;
    stopMonitorConfirmModalRef: any;
    pendingMonitorAuthCode: string = '';
    pendingMonitorLastName: string = '';

    @ViewChild('pageVooDoo')
    footerArea: ElementRef | undefined;

    @ViewChild('ConfirmMaskingStatusChangeModal')
    confirmMaskingStatusChangeModal!: TemplateRef<any>;

    constructor(
        private http: HttpClient,
        private authenticationService: AuthenticationService,
        public router: Router,
        private recordsService: RecordsService,
        public driverRecordRequestService: DriverRecordRequestService,
        private modalService: NgbModal,
        private auditService: AuditService,
        public translationService: TranslatorService,
        public generalService: GeneralService) {

        this.userProfile = this.authenticationService.getUserProfile() as UserProfile;
        this.isIahCustomer = (this.userProfile.customerType === 2);
        this.customerId = this.userProfile!.customerId;

        this.getColumnDefs().then((r) => this.loadColumnDefs(r));
        this.lang = this.translationService.getActiveLanguage().toUpperCase();
    }

    get currentTransaction() {
        return this.currentTrans;
    }

    // ********************** Lifecycle Events ********************** //
    ngOnInit(): void {
        //detect language change
        this.translationService._hasChanges$.subscribe(newValue => {
            if (newValue === true) {
                this.translationService.resetHasChange();
                this.lang = this.translationService.getActiveLanguage().toUpperCase();
            }
        });
        
        this.username = this.authenticationService.getUserName();
        this.gridLanguage = this.translationService.getActiveLanguage().toUpperCase();
        this.getColumnDefs().then((r) => this.loadColumnDefs(r));
    }

    loadColumnDefs(r: any) {
        if (r !== undefined) {
            this.columnDefs = r;
        }
    }

    onGridReady(params: any) {
        this.populateRecords(false);
        this.gridApi = params.api;
        this.smartSizeColumns();
    }

    // ********************** Grid Data ********************** //

    refreshGrid(scope: any) {
        this.isLoading = true;
        this.getColumnDefs().then((r) => this.loadColumnDefs(r));

        this.lang = this.translationService.getActiveLanguage().toUpperCase();

        this.overlayLoadingTemplate = `<span class="ag-overlay-loading-center">${this.loadingText}</span>`;
        this.overlayNoRowsTemplate = '<span class="italic" id="noResultsFound">No results found</span>';
        setTimeout(function () {
            scope.smartSizeColumns();
        }, 2000);
        this.scrollToTop();
        this.isLoading = false;
    }

    fileNamesDisplay() {
        if (this.probationDocuments.length > 0) {
            const separator = ', ';
            let display = this.probationDocuments[0].fileName;
            for (let index = 0; index < this.probationDocuments.length - 1; index++) {
                if (index > 0) {
                    display = display.concat(separator, this.probationDocuments[index].fileName)
                }
            }
        }
    }

    // ********************** Grid Data ********************** //

    populateRecords(refreshGrid: boolean) {
        const scope = this;
        this.recordsService.getAccountHolderRecordsObservable(1, 8000, 'RequestDate', 'desc', '', this.searchCriteria.searchString)
            .subscribe((response: any) => {
                this.rowData$ = response.items as DriverDashboardRecord[];
                if (this.footerArea) {
                         this.generalService.gridFooterTxt(this.footerArea as ElementRef);
                    }
                if (refreshGrid) {
                    scope.refreshGrid(scope);
                } else {
                    scope.smartSizeColumns();
                    scope.isLoading = false;
                }
            });
    }

    async getColumnDefs() {
        const pageScope = this;
        // pageScope.updateTranslatedText(pageScope);
        const promise = new Promise((resolve, reject) => {

            const expired: DateTime = DateTime.now()
                .minus({ hours: Number(environment.APP_DRIVER_RECORD_EXPIRATION_HOURS) })
                .endOf('hour');

            const isIahCustomer: boolean = pageScope.isIahCustomer;
            let records = [
                {
                    headerValueGetter: (params: any) => { return pageScope.generalService.getTranslation('transCol1') },
                    field: 'requestDate',
                    valueFormatter: (params: any) => this.formatDate(params),
                    sortable: true,
                    minWidth: 155,
                    maxWidth: 180,
                    flex: 2,
                },
                {
                    // Last name and open as HTML link
                    headerValueGetter: (params: any) => { return pageScope.generalService.getTranslation('LastName') },
                    field: 'lastName',
                    sortable: true,
                    minWidth: 110,
                    flex: 2,
                    resizable: true,
                    suppressSizeToFit: false,
                    cellRenderer: CelllinkrendererComponent,
                    cellRendererParams: {
                        hoverText: function(params: any) { 
                             return pageScope.generalService.getTranslation('View')
                        },
                        hideLink: function (params: any) {
                            if (params!.data!.probationStatusId != null && params!.data!.probationStatusId !== '3') return true;
                            return DateTime.fromISO(params!.data!.requestDate) < expired;
                        },
                        linkName: function (params: any) { return 'view_' + params!.data!.authCode; },
                        callback: function (celLValue: string, authCode: string, driversConsent: boolean) {
                            try {
                                const componentScope = pageScope;
                                if (driversConsent === false) {
                                    pageScope.router.navigateByUrl(`/byAuthCode/${authCode}`);
                                } else {
                                    const request: RenderDriverReportRequest = { asPdf: false, authCode: authCode, driverIP: '' };
                                    componentScope.driverRecordRequestService.getEndUserIp()
                                        .then((result: any) => {
                                            request.driverIP = result;
                                            const reportView: DriverReportView = {
                                                accessedVia: componentScope.accessedVia,
                                                accessedBy: componentScope.username,
                                                accessorCustomerId: componentScope.customerId,
                                                authCode: authCode,
                                                authenticationMethod: componentScope.authMethod,
                                                accessedDateTime: DateTime.now().toJSDate()
                                            }
                                            componentScope.driverRecordRequestService.openDriverReport(request, reportView)
                                                .then((v: string | any) => {
                                                    componentScope.openInBrowser(v);
                                                })
                                                .catch((error: any) => {
                                                    console.error(error);
                                                });
                                        }).catch((error: any) => {
                                            console.error(error);
                                            const reportView: DriverReportView = {
                                                accessedVia: componentScope.accessedVia,
                                                accessedBy: componentScope.username,
                                                accessorCustomerId: componentScope.customerId,
                                                authCode: authCode,
                                                authenticationMethod: componentScope.authMethod,
                                                accessedDateTime: DateTime.now().toJSDate()
                                            }
                                            componentScope.driverRecordRequestService.openDriverReport(request, reportView)
                                                .then((v: string | any) => {
                                                    const reportView: DriverReportView = {
                                                        accessedVia: componentScope.accessedVia,
                                                        accessedBy: componentScope.username,
                                                        accessorCustomerId: componentScope.customerId,
                                                        authCode: authCode,
                                                        authenticationMethod: componentScope.authMethod,
                                                        accessedDateTime: DateTime.now().toJSDate()
                                                    }
                                                    componentScope.openInBrowser(v);
                                                })
                                                .catch((error: any) => {
                                                    console.error(error);
                                                });
                                        });
                                }

                            } catch (error) {
                                console.error(error);
                            }
                        }
                    }
                },
                {
                    headerValueGetter: (params: any) => { return pageScope.generalService.getTranslation('license_num_hash') },
                    field: 'driverLicenseNumber',
                    tooltipField: 'driverLicenseNumber',
                    sortable: true,
                    minWidth: 100,
                    flex: 2,
                    resizable: true,
                },
                {
                    headerValueGetter: (params: any) => { return pageScope.generalService.getTranslation('State') },
                    field: 'driverLicenseState',
                    tooltipField: 'driverLicenseState',
                    sortable: true,
                    minWidth: 85,
                    maxWidth: 85,
                    flex: 2,
                },
                {
                    headerValueGetter: (params: any) => { return pageScope.generalService.getTranslation('transCol6') },
                    field: 'userName',
                    tooltipField: 'userName',
                    sortable: true,
                    minWidth: 135,
                    flex: 2,
                    resizable: true,
                },
                {
                    headerValueGetter: (params: any) => { return pageScope.generalService.getTranslation('monitor_grid_heading') },
                    field: 'monitor',
                    sortable: true,
                    minWidth: 95,
                    maxWidth: 95,
                    flex: 2,
                    cellRenderer: CheckboxcellrendererComponent,
                    cellRendererParams: {
                        isDisabled: function (params: any) {
                            if (isIahCustomer) {
                                return true;
                            }
                            const nullDate = '0001-01-01T00:00:00';
                            const notified: string = params!.data!.monitorNotified ?? nullDate;
                            const notifiedDate: DateTime | null = notified > nullDate
                                ? DateTime.fromISO(notified)
                                : null;
                            if (notifiedDate?.isValid) {
                                return true;
                            }
                            return false;
                        },
                        hideCheckbox: function (params: any) {
                            if (params!.data!.monitorParentAuthCode){
                                return true;
                            }
                            return false;
                        },
                        onMonitorChange: function (authCode: string, monitor: boolean, lastName: string, requestDate: string) {
                            // If opting OUT on an expired record, warn first
                            if (!monitor) {
                                const recordExpired = DateTime.fromISO(requestDate) < expired;
                                if (recordExpired) {
                                    pageScope.pendingMonitorAuthCode = authCode;
                                    pageScope.pendingMonitorLastName = lastName;
                                    pageScope.stopMonitorConfirmModalRef = pageScope.modalService.open(
                                        pageScope.stopMonitorConfirmModal,
                                        { ariaLabelledBy: 'stopMonitorConfirmModalTitle' }
                                    );
                                    return;
                                }
                            }
                            // action logging occurs on the backend when the monitor state is updated, so no need to log here
                            pageScope.isLoading = true;
                            pageScope.recordsService.updateMonitorState(authCode, monitor)
                                .then((success: boolean) => {
                                    if (success) {
                                        pageScope.monitorToastLastName = lastName;
                                        pageScope.monitorToastOptIn = monitor;
                                        pageScope.showMonitorToast = true;
                                    }
                                })
                                .catch((error: any) => {
                                    console.error(error);
                                    pageScope.monitorErrorToastIs401 = error?.response?.status === 401;
                                    pageScope.monitorErrorToastIs403 = error?.response?.status === 403;
                                    pageScope.monitorErrorToast403AuthCode = authCode;
                                    pageScope.showMonitorErrorToast = true;
                                })
                                .finally(() => {
                                    pageScope.isLoading = false;
                                });
                        },
                        showAltIcon: function (params: any) {
                            if (params!.data!.monitorParentAuthCode) {
                                return true;
                            }
                            return false;
                        },
                        altIconClass: 'fa fa-info',
                        altIconLabel: function (params: any) {
                            return `${pageScope.generalService.getTranslation('MonitorReorderNotAllowedPopover')}`;
                        },
                    }
                },
                {
                    headerValueGetter: (params: any) => { return pageScope.generalService.getTranslation('Actions') },
                    field: 'authCode',
                    sortable: false,
                    // The width is so high because of the lenght of French text for "Under Review"
                    minWidth: 280,
                    maxWidth: 280,
                    flex: 2,
                    suppressSizeToFit: false,
                    cellRenderer: CustomercellbuttonrendererComponent,
                    cellRendererParams: {
                        // Download Report Button
                        // Note: The "button" properties are for the download report button.
                        buttonText: function(params: any) { 
                             return pageScope.generalService.getTranslation('Download');
                        },
                        buttonClass: 'btn btn-primary btn-sm mt-n1',
                        buttonIcon: '',
                        hideButton: function (probationStatusId: string, requestDate: string) {
                            if (probationStatusId != null && probationStatusId !== '3') {
                                /* HIDE BUTTON if: is on probation and transaction is NOT approved */
                                return true;
                            } else {
                                /* SHOW BUTTON otherwise (expired records show a disabled button) */
                                return false;
                            }
                        },
                        disableButton: function (probationStatusId: string, requestDate: string) {
                            /* DISABLE BUTTON if: transaction is expired (> 5 days old) */
                            return DateTime.fromISO(requestDate) < expired;
                        },
                        buttonName: function (authCode: string) {
                            return 'download_' + authCode;
                        },
                        hideButtonText: '',
                        function(params: any) {
                            return 'download_' + params.data.authCode;
                        },
                        callback: function (authCode: string, driversConsent: boolean) {
                            if (driversConsent === false) {
                                pageScope.router.navigateByUrl(`/byAuthCode/${authCode}`);
                            } else {
                                /* Get report */
                                const componentScope = pageScope;
                                const reportView: DriverReportView = {
                                    accessedVia: componentScope.accessedVia,
                                    accessedBy: componentScope.username,
                                    accessorCustomerId: componentScope.customerId,
                                    authCode: authCode,
                                    authenticationMethod: componentScope.authMethod,
                                    accessedDateTime: DateTime.now().toJSDate()
                                };
                                
                                pageScope.driverRecordRequestService.getDriverReportPdf(authCode, reportView)
                                    .then((v: any) => componentScope.openPdf(v))
                                    .catch((error: any) => {
                                        console.error(error);
                                    });
                            }
                        },

                        // Probation Button
                        probationButtonClass: 'btn btn-primary btn-sm mt-n1 text-nowrap',
                        probationButtonIcon: '',
                        hideProbationButton: function (params: any) {
                            /* SHOW BUTTON if: is on probation and transaction is NOT approved */
                            return (params!.data!.probationStatusId !== null && params!.data!.probationStatusId !== '3') ? false : true;
                        },
                        probationButtonName: function (params: any) {
                            return 'probation_' + params.data.authCode;
                        },
                        probationButtonText: function (params: any) {
                            if (pageScope.isIahCustomer && params!.data!.probationStatusId !== null && params!.data!.probationStatusId !== '3') {
                                return pageScope.generalService.getTranslation('Wiz_Submit')
                            } else if (params!.data!.probationStatusId !== null) {
                                switch (params!.data!.probationStatusId) {
                                    case '1': {
                                        if (params!.data!.documentId  === null) {
                                           return pageScope.generalService.getTranslation('resubmitProbationModalTitle');
                                        } else {
                                           return pageScope.generalService.getTranslation('pendingUnderReviewModalTitle');
                                        }
                                        break;
                                    }
                                    case '2': {
                                        return pageScope.generalService.getTranslation('Wiz_Submit');
                                        break;
                                    }
                                    case '4': {
                                        return pageScope.generalService.getTranslation('resubmitProbationModalTitle');
                                        break;
                                    }
                                    default: {
                                        return '';
                                    }
                                }
                            } else {
                                return '';
                            }
                        },
                        probationButtonCallback: function (authCode: string, probationStatusId: string, documentId: string, firstName: string, lastName: string, requestDate: string) {
                            // Store current transaction data
                            const componentScope = pageScope;
                            componentScope.currentAuthCode = authCode;
                            componentScope.currentTrans!.authCode = authCode;
                            componentScope.currentTrans!.probationStatusId = probationStatusId;
                            componentScope.currentTrans!.documentId = documentId;
                            componentScope.currentTrans!.firstName = firstName;
                            componentScope.currentTrans!.lastName = lastName;
                            componentScope.currentTrans!.requestDate = requestDate;

                            if (pageScope.isIahCustomer && probationStatusId !== '3') {
                                /* Go to IAH consent page */
                                const url: string = `${environment.APP_PSP_BASE_URL}/byAuthCode/${authCode}`;
                                window.location.href = url;
                            } else {
                                switch (probationStatusId) {
                                    case '1': {
                                        if (documentId === null) {
                                            componentScope.isSubmitStatus = true;
                                            componentScope.modalService.open(componentScope.submitOrResubmitModal, { ariaLabelledBy: 'submitOrResubmitModalTitle' });
                                        } else {
                                            componentScope.showPendingUnderReviewModal = true;
                                            componentScope.modalService.open(componentScope.pendingUnderReviewModal, { ariaLabelledBy: 'pendingUnderReviewModalTitle' });
                                        }
                                        break;
                                    }
                                    case '2': {
                                        componentScope.isResubmit = true;
                                        componentScope.isResubmitStatus = true;
                                        componentScope.modalService.open(componentScope.submitOrResubmitModal, { ariaLabelledBy: 'submitOrResubmitModalTitle' });
                                        break;
                                    }
                                    case '4': {
                                        componentScope.isResubmit = true;
                                        componentScope.isResubmitStatus = true;
                                        componentScope.modalService.open(componentScope.submitOrResubmitModal, { ariaLabelledBy: 'submitOrResubmitModalTitle' });
                                        break;
                                    }
                                }
                            }
                        },

                        // Reorder Button reorder_ah_grid_button
                        reorderButtonText: function(params: any) { 
                             return pageScope.generalService.getTranslation('reorder_ah_grid_button');
                        },
                        reorderButtonClass: 'btn btn-warning btn-sm mt-n1 ms-3 text-nowrap',
                        reorderButtonIcon: '',
                        reorderButtonPopoverText: function (params: any) {
                            if (params!.data!.monitorNotified) {
                                 const nullDate = '0001-01-01T00:00:00';
                                const notified: string = params!.data!.monitorNotified ?? nullDate;
                                const formattedDate = notified > nullDate
                                    ? DateTime.fromISO(notified).toFormat('MM/dd/yyyy')
                                    : '';
                                return `${pageScope.generalService.getTranslation('ReorderPopoverPrefix')} ${formattedDate} ${pageScope.generalService.getTranslation('ReorderPopoverSuffix')}`;
                            } else {
                                return '';
                            }
                        },
                        reorderButtonName: function (params: any) {
                            return 'reorder_' + params.data.authCode;
                        },
                        hideReorderButton: function (params: any) {
                            if (isIahCustomer) {
                                return true;
                            }
                            const nullDate = '0001-01-01T00:00:00';
                            const notified: string = params!.data!.monitorNotified ?? nullDate;
                            const notifiedDate: DateTime | null = notified > nullDate
                                ? DateTime.fromISO(notified)
                                : null;
                            return !notifiedDate?.isValid;
                        },
                        reorderButtonCallback: function (authCode: string) {
                            pageScope.router.navigate(['/requestRecords'], { queryParams: { reorderAuthCode: authCode } });
                        },
                        reorderButtonDisabled: function (params: any) {
                            if (params.data.monitorReorderDateTime && params.data.monitorReorderDateTime > params.data.monitorNotified){
                                // The record has been reordered after the last MCMIS upload. 
                                return true;
                            } else {
                                return false;
                            }
                        }
                    }
                },
            ];
            resolve(records);
        });
        return await promise;
    }


    // ********************** Search & Filter ********************** //

    ngDoCheck() {
        this.doCheckCount++;
        if (this.searchCriteria.searchString !== this.oldSearchCriteria.searchString) {
            this.oldSearchCriteria = Object.assign({}, this.searchCriteria);
            this.populateRecords(true);
        }
    }

    cleanModel() {
        const voodoo = null;
        if (voodoo) {
            const document: Document = (voodoo as HTMLElement).ownerDocument;
            const agUnselectableClassed: NodeListOf<HTMLElement> = document.querySelectorAll('.ag-body-horizontal-scroll, .ag-overlay');
            agUnselectableClassed.forEach((el: HTMLElement) => {
                el.removeAttribute('aria-hidden')
            });
        }
    }

    // ********************** View & Download Report ********************** //

    openPdf(buffer: any) {
        const filename = "DriverReport.pdf";
        const element = document.createElement('a');
        element.setAttribute('href', 'data:application/pdf;base64,' + buffer);
        element.setAttribute('download', filename);
        element.style.display = 'none';
        document.body.appendChild(element);
        element.click();
        document.body.removeChild(element);
    }

    openInBrowser(contentToRender: string) {
        if (contentToRender && contentToRender.length === 0) {
            this.router.navigateByUrl('/customerSupportInfo');
        }
        const blob = new Blob([contentToRender], { type: 'text/html' });
        const url = URL.createObjectURL(blob);
        const faxWindow = window.open(url);
        if (faxWindow) {
            faxWindow.onload = () => {
                URL.revokeObjectURL(url);
            };
            faxWindow?.focus();
        } else {
            // If popup blocked
            console.warn('Popup blocked. Please allow popups for this site.');
            // Revoke even if not opened to prevent memory leaks
            URL.revokeObjectURL(url);
        }
    }

    // ********************** Formatting ********************** //
    formatDate(params: any) {
        if (params.value && params.value !== '') {
            return DateTime.fromISO(params.value).toFormat('MM/dd/yyyy');
        }
        return '';
    } 

    smartSizeColumns() {
        let colsToHide = [];
        let colsToShow = [];
        
        if (innerWidth < 1200) {
            colsToHide.push('requestDate');
        } else {
            colsToShow.push('requestDate');
        }

        if (innerWidth < 992) {
            colsToHide.push('userName');
        } else {
            colsToShow.push('userName');
        }

        if (innerWidth < 768) {
            colsToHide.push('driverLicenseState');
            colsToHide.push('monitor');
        } else {
            colsToShow.push('driverLicenseState');
            colsToShow.push('monitor');
        }

        this.gridApi.setColumnsVisible(colsToHide, false);
        this.gridApi.setColumnsVisible(colsToShow, true);
        this.gridApi.sizeColumnsToFit();

    }

    executeCoverSheet() {
        this.modalService.dismissAll();
        this.isSubmitStatus = false;
        this.isResubmitStatus = false;
        const thisWindow = window;
        if (this.coversheetType === '') {
            return;
        }

        window.onbeforeunload = null;
        if (this.coversheetType === 'email') {
            this.isLoading = true;

            const emailLink = this.auditService.getProbationEmailLink(this.currentAuthCode)
                .then((result: any | any) => {
                    this.isLoading = false;
                    thisWindow.open(result, "_self");
                    thisWindow.onbeforeunload = null;
                })
                .catch((error: any) => {
                    console.error(error);
                    thisWindow.onbeforeunload = null;
                    this.isLoading = false;
                });
        } else if (this.coversheetType === 'online') {
            this.modalService.open(this.uploadModal, { size: 'lg', ariaLabelledBy: 'uploadModalTitle' });
            this.showUploadModal = true;
        } else {
            this.isLoading = true;

            const auditServicePromise = this.auditService.getFaxCoverSheet(this.currentAuthCode)
                .then((result: any | any) => {
                    this.isLoading = false;
                    const htmlContent = result.data;
                    const blob = new Blob([htmlContent], { type: 'text/html' });
                    const url = URL.createObjectURL(blob);
                    const faxWindow = window.open(url, '_blank', 'width=800,height=800,scrollbars=yes,resizable=yes');
                    if (faxWindow) {
                        faxWindow.onload = () => {
                            URL.revokeObjectURL(url);
                        };
                        faxWindow?.focus();
                    } else {
                        // If popup blocked
                        console.warn('Popup blocked. Please allow popups for this site.');
                        URL.revokeObjectURL(url); // Revoke even if not opened to prevent memory leaks
                    }
                })
                .catch((error: any) => {
                    console.error(error);
                    thisWindow.onbeforeunload = null;
                    this.isLoading = false;
                });
        }
        this.coversheetType = '';
    }

    cancelCoverSheet() {
        this.modalService.dismissAll();
        this.isSubmitStatus = false;
        this.isResubmitStatus = false;
        this.coversheetType = '';
    }

    dismissUnderReviewModal() {
        this.modalService.dismissAll();
        this.showPendingUnderReviewModal = false;
    }

    confirmStopMonitoring() {
        this.stopMonitorConfirmModalRef?.close();
        this.isLoading = true;
        this.recordsService.updateMonitorState(this.pendingMonitorAuthCode, false)
            .then((success: boolean) => {
                if (success) {
                    this.monitorToastLastName = this.pendingMonitorLastName;
                    this.monitorToastOptIn = false;
                    this.showMonitorToast = true;
                    this.populateRecords(true);
                }
            })
            .catch((error: any) => {
                console.error(error);
                this.monitorErrorToastIs401 = error?.response?.status === 401;
                this.monitorErrorToastIs403 = error?.response?.status === 403;
                this.monitorErrorToast403AuthCode = this.pendingMonitorAuthCode;
                this.showMonitorErrorToast = true;
            })
            .finally(() => {
                this.isLoading = false;
                this.pendingMonitorAuthCode = '';
                this.pendingMonitorLastName = '';
            });
    }

    cancelStopMonitoring() {
        this.stopMonitorConfirmModalRef?.close();
        this.gridApi.refreshCells({ force: true });
        this.pendingMonitorAuthCode = '';
        this.pendingMonitorLastName = '';
    }

    removeDocument(docId: string) {
        this.auditService.removeDocument(docId, this.currentTrans.authCode)
            .then((result: any) => {
                if (result && result === 'unauthorized') {
                    console.error('User not authorized to delete document.');
                    this.router.navigateByUrl('/accessDenied');
                } else if (result && result.length > 0) {
                    this.probationDocuments.splice(this.probationDocuments.indexOf(docId), 1);
                } else {
                    console.error('Error occurred deleting document');
                    this.router.navigateByUrl('/applicationException');
                }
            }).catch((error: any) => {
                console.error('Error deleting document.');
                console.error(error);
                this.router.navigateByUrl('/applicationException');
            });
    }

    closeUploadModal() {
        this.modalService.dismissAll();
        this.currentTrans = {};
        this.showUploadModal = false;
    }

    cancelUploads() {
        //if the upload modal is dismissed in this way we must remove the documents that may have been uploaded
        this.closeUploadModal();
        this.isLoading = true;

        this.probationDocuments.forEach((doc: any) => {
            this.auditService.removeDocument(doc.documentId, this.currentTrans.authCode);
        });
        this.probationDocuments = [];

        this.isLoading = false;
    }

    completeDocumentUploads() {
        // Update transaction status and notify CSRs if documents have been uploaded
        if (this.probationDocuments.length > 0) {
            this.isLoading = true;
            this.auditService.updateProbationTransactionStatus(this.currentTrans.authCode, 1)
                .then((statusResult: any) => {
                    this.auditService.sendProbationUploadEmail(this.currentTrans.firstName, this.currentTrans.lastName, this.currentTrans.requestDate)
                        .then((result: any) => {
                            this.probationDocuments = [];
                            this.closeUploadModal();
                            this.populateRecords(true);
                        });
                });
        } else {
            this.probationDocuments = [];
            this.closeUploadModal();
        }
    }

    showDocument(documentId: string) {
        this.generalService.logActivity('audit_document::view', this.username);
        const docUrl = `${environment.APP_API_URL}/Documents/${documentId}`;
        window.open(docUrl, '', 'width=800,height=600,resizable=1');
    }

    showPdfDocument(documentId: string) {
        
        this.generalService.logActivity('audit_document::view', this.username);
        this.pdfUrl = `${environment.APP_API_URL}/Documents/${documentId}`;
        window.open(this.pdfUrl, '', 'width=800,height=600,resizable=1');
    }

    getPDFDocumentUrl(documentId: string) {
        
        this.generalService.logActivity('audit_document::view', this.username);
        return `${environment.APP_API_URL}/Documents/${documentId}`;
    }

    uploadDocuments(event: any) {
        this.isValidFileType = true;
        if (event.target && event.target.files && event.target.files.length > 0) {
            Array.from(event.target.files).forEach((file: any) => {
                if (file.name) {
                    const nameParts: string[] = file.name.split('.');
                    const fileExtension = nameParts[nameParts.length - 1].toLowerCase();
                    if (fileExtension === 'pdf' || fileExtension === 'jpg' || fileExtension === 'png' || fileExtension === 'jpeg') {
                        this.isValidFileType = true;
                        this.auditService.auditFiles.push(file);
                    } else {
                        this.isValidFileType = false;
                        this.invFileTypeModal = this.modalService.open(this.invalidFileTypeModal, { size: 'lg', ariaLabelledBy: 'invalidFileTypeModalTitle' });
                        event.target.value = '';
                        return;
                    }
                }
            });
        } else if (event.dataTransfer && event.dataTransfer.files && event.dataTransfer.files.length > 0) {
            Array.from(event.dataTransfer.files).forEach((file: any) => {
                if (file.name) {
                    const nameParts: string[] = file.name.split('.');
                    const fileExtension = nameParts[nameParts.length - 1].toLowerCase();
                    if (fileExtension === 'pdf' || fileExtension === 'jpg' || fileExtension === 'png' || fileExtension === 'jpeg') {
                        this.isValidFileType = true;
                        this.auditService.auditFiles.push(file);
                    } else {
                        this.isValidFileType = false;
                        this.invFileTypeModal = this.modalService.open(this.invalidFileTypeModal, { size: 'lg', ariaLabelledBy: 'invalidFileTypeModalTitle' });
                        event.target.value = '';
                        return;
                    }
                }
            });
        } else {
            // no files. User may have cancelled out of file windows file explorer when selecting file.
            event.target.value = '';
            return;
        }

        if (this.isValidFileType) {
            this.isUploading = true;
            this.auditService.uploadAuditDocuments(this.currentTrans.authCode, this.username, true)
                .then((result: any) => {
                    if (result && result === 'unauthorized') {
                        console.error('User not authorized to upload audit documents.');
                        event.target.value = '';
                        this.router.navigateByUrl('/accessDenied');
                    } else if (result && result.length > 0) {
                        result.forEach((result: any) => {
                            this.probationDocuments.push({
                                'created': result.created,
                                'creator': result.creator,
                                'documentId': result.documentId,
                                'fileName': result.fileName,
                                'mimeTypeId': result.mimeTypeId
                            });
                        });
                        this.auditService.auditFiles = [];
                        this.isUploading = false;
                        event.target.value = '';
                    }
                }).catch((error: any) => {
                    console.error('Error uploading audit documents');
                    console.error(error);
                    this.isUploading = false;
                    event.target.value = '';
                });
        } else {
            event.target.value = '';
        }
    }

    closeInvalidFileTypeModal() {
        this.isUploading = false;
        this.invFileTypeModal.close();
    }

    onFileUpload(event: any) {
    }


    translate(translationTag: string) {
        this.lang = this.translationService.getActiveLanguage().toUpperCase();

        if (translationTag === 'Voodoo' && this.gridLanguage !== this.lang as string) {
            this.gridLanguage = this.lang;
            this.getColumnDefs().then((r) => this.loadColumnDefs(r));
            this.smartSizeColumns();

            console.log(this.footerArea)
            if (this.footerArea) {
                this.generalService.gridFooterTxt(this.footerArea as ElementRef);
            }
        }
        return this.doTranslation(translationTag);
    }

    doTranslation(translationTag: string): string {
        let translatedText: string = this.generalService.getTranslation(translationTag)
        if (translatedText === undefined) {
            translatedText = this.generalService.getTranslation(translationTag);
        }
        return translatedText;
    }

    scrollToTop() {
        window.scrollTo(0, 0);
        return false;
    }
}
